import Skeleton from '@mui/material/Skeleton';
import type React from 'react';
import { useListViewRowContext } from '../ListViewRowContext';

const TypeBadgeCell: React.FC = () => {
  const { loading, rowType, classes } = useListViewRowContext();

  if (loading) {
    return <Skeleton variant="rounded" width={24} height={18} animation="wave" sx={{ mx: 'auto', borderRadius: 3 }} />;
  }

  if (rowType === 'asset') {
    return <span className={classes.typeBadgeAsset}>A</span>;
  }

  return <span className={classes.typeBadgeGallery}>G</span>;
};

export default TypeBadgeCell;
